import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "overlay"]
  static values = { open: Boolean }

  toggle() {
    if (this.openValue) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.remove("-translate-x-full")
    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.openValue = true
  }

  close() {
    this.menuTarget.classList.add("-translate-x-full")
    this.overlayTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.openValue = false
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.openValue) {
      this.close()
    }
  }

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
    this.closeBeforeCache = this.close.bind(this)

    document.addEventListener("keydown", this.closeOnEscape)

    // Turbo snapshots the page on the way out. Navigating through the menu
    // means it is open at that moment, so the cached copy keeps it open and
    // the preview flashes the sidebar on the way back. Closing first makes
    // the snapshot match what the page should look like.
    document.addEventListener("turbo:before-cache", this.closeBeforeCache)
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
    document.removeEventListener("turbo:before-cache", this.closeBeforeCache)
    document.body.classList.remove("overflow-hidden")
  }
}